import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";

/**
 * Big floating CTA button visible on desktop after scrolling past the hero.
 * Hidden on mobile (mobile has its own sticky bar).
 */
export default function FloatingCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a
      href="#preventivo"
      data-testid="floating-cta"
      aria-label="Richiedi Preventivo Gratuito"
      className={`hidden lg:flex fixed bottom-8 right-8 z-40 items-center gap-3 h-16 pl-7 pr-5 rounded-full bg-brand-primary text-white font-bold text-base shadow-2xl shadow-brand-primary/40 hover:bg-brand-ink hover:scale-105 transition-all duration-500 animate-pulse-ring ${
        visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6 pointer-events-none"
      }`}
    >
      Richiedi Preventivo Gratuito
      <span className="w-10 h-10 rounded-full bg-white/15 flex items-center justify-center">
        <ArrowRight className="w-5 h-5" />
      </span>
    </a>
  );
}
